module.exports = {
  personalizeTags: [],
  sizeOptions: ["Größe"],
  colorOptions: ["Farbe"],
  colorMap: {
    Black: ["#00ff00", "#ff0000", "#ffff00"],
  },
  fontMap: {},
};
